<div class="surface-section card p-4">
  <!-- Page Header -->
  <div class="border-bottom-1 border-300 mb-6 pb-4">
    <div class="align-items-center justify-content-between flex">
      <div>
        <h2 class="text-900 m-0 mb-1 text-3xl font-semibold">{{ 'bookings.title' | translate }}</h2>
        <p class="text-600 mb-0 mt-0">{{ 'bookings.subtitle' | translate }}</p>
      </div>
    </div>
  </div>

  <!-- Filters -->
  <app-bookings-filters
    [activeFilter]="currentFilters"
    (filterChange)="onFilterChange($event)"
    (resetFilters)="onResetFilters()"
  >
  </app-bookings-filters>

  <!-- Table -->
  <app-bookings-table
    [filter]="currentFilters"
    (viewBookingDetails)="onViewBookingDetails($event)"
  >
  </app-bookings-table>
</div>
